import { vehicleTypesSlice } from "./vehicleTypesSlice";
import * as defaultActions from "../../../../../redux/_common";
import { Dispatch } from "redux";
import { constructInitialFilters } from "../../../../components/common/filters/utils";
import { get } from "../../../../../api/requester";
import { IEditItem, IValues } from "./_interfaces";
import * as fields from "../../pages/vehicleTypes/edit/constants";

const { actions } = vehicleTypesSlice;
export const moduleUrl = "/api/appmasterdata/vehicleTypes";

export const setValidationErrors = actions.setValidationErrors;

export const getVehicleTypes = (params: {}) => defaultActions.getItems(moduleUrl, actions, params);
export const getVehicleType = (id: string) => defaultActions.getItem(`${moduleUrl}/${id}`, actions, refineDataForTabs);
export const saveVehicleType = (vehicleType: {}, id: string | null) =>
  defaultActions.saveItem(moduleUrl, actions, vehicleType, id, refineDataForSaving, 'multipart/form-data;boundary="boundary"');
export const deleteVehicleType = (id: string) => defaultActions.deleteItem(`${moduleUrl}/${id}`, actions);
export const getDropDownItems = (params: {}) => defaultActions.getDropDownItems(`${moduleUrl}/select`, actions, params);

export const clearAll = () => defaultActions.clearAll(actions);
export const clearVehicleType = () => defaultActions.clearItem(actions);
export const clearErrors = () => defaultActions.clearErrors(actions);

const refineDataForTabs = (data: IEditItem) => {
  return {
    id: data.id,
    [fields.GENERAL]: {
      [fields.GENERAL_NAME]: data.name,
      [fields.GENERAL_CATEGORY_ID]: data.categoryId,
      [fields.GENERAL_SUB_CATEGORY_ID]: data.subCategoryId,
      [fields.GENERAL_MANUFACTURER_ID]: data.manufacturerId,
      [fields.GENERAL_MODEL_ID]: data.modelId,
      [fields.GENERAL_MAX_PAYLOAD]: data.maxPayload,
      [fields.GENERAL_MAX_VOLUME]: data.maxVolume,
      [fields.GENERAL_INTERIOR_LENGTH]: data.interiorLength,
      [fields.GENERAL_INTERIOR_WIDTH]: data.interiorWidth,
      [fields.GENERAL_INTERIOR_HEIGHT]: data.interiorHeight,
    },
    [fields.IMAGES]: data[fields.IMAGES] || [],
  };
};

const refineDataForSaving = (data: IValues) => {
  const toNumberOrNull = (value: unknown): number | null => {
    if (value === null || value === undefined || value === "") {
      return null;
    }

    const parsed = Number(value);
    return Number.isNaN(parsed) ? null : parsed;
  };

  const files: File[] = [];

  const createVehicleTypeImages: IValues["createVehicleTypeImages"] = [];
  const updateVehicleTypeImages: IValues["updateVehicleTypeImages"] = [];

  data.vehicleTypeImages?.forEach((image) => {
    if (image?.action === "create") {
      image.file && files.push(image.file);
      createVehicleTypeImages.push({
        fileName: image.file?.name || "n/a",
        isDefault: image.isDefault,
      });
    } else if (image?.action === "update") {
      updateVehicleTypeImages.push({
        id: image.id,
        isDefault: image.isDefault,
      });
    }
  });

  const form = {
    ...(data.id && { id: data.id }),
    [fields.GENERAL_NAME]: data.general.name,
    [fields.GENERAL_CATEGORY_ID]: data.general.categoryId,
    [fields.GENERAL_SUB_CATEGORY_ID]: data.general.subCategoryId,
    [fields.GENERAL_MANUFACTURER_ID]: data.general.manufacturerId,
    [fields.GENERAL_MODEL_ID]: data.general.modelId,
    [fields.GENERAL_MAX_PAYLOAD]: toNumberOrNull(data.general.maxPayload),
    [fields.GENERAL_MAX_VOLUME]: toNumberOrNull(data.general.maxVolume),
    [fields.GENERAL_INTERIOR_LENGTH]: toNumberOrNull(data.general.interiorLength),
    [fields.GENERAL_INTERIOR_WIDTH]: toNumberOrNull(data.general.interiorWidth),
    [fields.GENERAL_INTERIOR_HEIGHT]: toNumberOrNull(data.general.interiorHeight),
    createVehicleTypeImages,
    updateVehicleTypeImages,
    deleteVehicleTypeImages: data.deleteVehicleTypeImages,
  };

  const formData = new FormData();
  formData.append("command", JSON.stringify(form));
  files.forEach((file) => {
    formData.append("files", file);
  });

  return formData;
};

export const getFilters = () => async (dispatch: Dispatch) => {
  try {
    const vehicleCategories: any[] = await get("/api/appmasterdata/vehicleCategories/complexSearch");
    const vehicleSubCategories: any[] = await get("/api/appmasterdata/vehicleSubcategories/complexSearch");
    const vehicleManufacturers: any[] = await get("/api/appmasterdata/vehicleManufacturers/complexSearch");
    const vehicleModels: any[] = await get("/api/appmasterdata/vehicleModels/complexSearch");

    dispatch(
      actions.setFilter(
        constructInitialFilters([
          ...(vehicleCategories || []),
          ...(vehicleSubCategories || []),
          ...(vehicleManufacturers || []),
          ...(vehicleModels || []),
        ]),
      ),
    );
  } catch (error) {
    // handled by empty filters fallback
  }
};

export const setFilter = (filters: any) => defaultActions.setFilters(filters, actions);
